<template>
  <div class="w-100 my-5">
    <div v-if="userList">
      <div class="row mx-auto box-white" v-if="($route.params.type >= -1 && $route.params.type <= 1)">
        <div class="col-sm my-1 vertical-center" v-if="($route.params.type == 1)">
          <span class="font-bold font-15 alpha-07">{{ $t('organizer') }}:</span>
          <span class="mx-5 font-bold font-20">{{ statsMap ? statsMap['user'].organizer : 0 }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-else-if="($route.params.type == -1)">
          <span class="font-bold font-15 alpha-07">{{ $t('unapproved_organizer') }}:</span>
          <span class="mx-5 font-bold font-20">{{ statsMap ? statsMap['user'].unapproved : 0 }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-else>
          <span class="font-bold font-15 alpha-07">{{ $t('single_user') }}:</span>
          <span class="mx-5 font-bold font-20">{{ statsMap ? (statsMap['user'].total - statsMap['user'].organizer - statsMap['user'].unapproved) : 0 }}</span>
        </div>
        <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
          <input class="w-75" v-model="keyword" />
          <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
            <i class="flaticon-circle"></i>
          </v-btn>
        </div>
      </div>
      <div class="row my-5" v-if="(items.length > 0)">
        <div :class="`col-sm${colSmSize}`" v-for="(item, index) in items" :key="(item, index)">
          <div class="my-2 box-white d-flex flex-column">
            <div class="vertical-center pointer" @click="$router.push(`/users/${userType}/${item.userId}`)">
              <img class="circle-image-80" :src="item.photoUrl ? item.photoUrl : assets.profile" />
              <div class="ml-5 d-flex flex-column">
                <div class="mt-2 vertical-center">
                  <i class="fa fa-user font-12 color-black"></i>
                  <span class="ml-2 font-bold font-15">{{ item.userName }}</span>
                </div>
                <div class="mt-2 vertical-center" v-if="item.email">
                  <i class="socicon-mail font-12 color-black"></i>
                  <span class="ml-2 font-12">{{ item.email }}</span>
                </div>
                <div class="mt-2 vertical-center" v-if="item.phone">
                  <i class="fa fa-phone font-12 color-black"></i>
                  <span class="ml-2 font-12">{{ item.phone }}</span>
                </div>
                <div class="mt-2 vertical-center">
                  <i class="fa fa-calendar-alt font-12 color-black"></i>
                  <span class="ml-2 font-12">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
                </div>
              </div>
            </div>
            <div class="mt-5 d-flex justify-content-end vertical-center" v-if="(item.userType === -1)">
              <v-btn class="button-normal" small @click="setUserTypeTask(item.userId, 1)">
                <span>{{ $t('approve') }}</span>
              </v-btn>
              <v-btn class="ml-5 button-normal" small @click="setUserTypeTask(item.userId, 0)">
                <span>{{ $t('decline') }}</span>
              </v-btn>
            </div>
            <div class="mt-5 d-flex justify-content-end vertical-center" v-else>
              <v-btn class="button-normal" small @click="$router.push(`/event/events/${item.userId}`)" v-if="(item.userType === 1)">
                <span>{{ $t('event') }}</span>
              </v-btn>
              <v-btn class="ml-5 button-normal" small @click="$router.push(`/transaction/transactions/u/${item.userId}`)" v-if="(item.userType === 0 || item.userType === 1)">
                <span>{{ $t('transaction') }}</span>
              </v-btn>
              <v-btn class="ml-5 button-normal" small @click="$router.push(`/coupons/${item.userId}`)" v-if="(item.userType === 2)">
                <span>{{ $t('coupon_code') }}</span>
              </v-btn>
              <v-btn class="ml-5 button-normal" small @click="$router.push(`/transaction/withdraws/u/${item.userId}`)" v-if="(item.userType === 1)">
                <span>{{ $t('withdraw') }}</span>
              </v-btn>
            </div>
            <div class="mt-5 d-flex justify-content-end vertical-center" v-if="(item.userType === 1)">
              <v-btn class="button-normal button-normal" small @click.stop="openServiceFeeModal(item)">
                <span>{{ $t('change_service_fee') }}</span>
              </v-btn>
            </div>
            <div class="my-3 d-flex justify-content-between vertical-center" v-if="item.deletedAt">
              <i class="fa fa-calendar-alt font-12 color-black"></i>
              <span class="ml-2 font-12 color-black">{{ getDateStringFromTimestamp(item.deletedAt) }}</span>
              <i class="ml-auto font-12 color-black">[{{ $t('deleted') }}]</i>
            </div>
            <div class="mt-3 d-flex justify-content-between vertical-center" v-else-if="item.blockedAt">
              <i class="fa fa-calendar-alt font-12 color-black"></i>
              <span class="mx-2 font-12 color-black">{{ getDateStringFromTimestamp(item.blockedAt) }}</span>
              <v-btn class="mr-auto" icon small @click="$toast.info(item.blockedReason)">
                <i class="flaticon-info color-black"></i>
              </v-btn>
              <v-btn class="ml-5 button-normal" small @click="blockUserTask(item.userId, false)">
                <span>{{ $t('unblock') }}</span>
              </v-btn>
            </div>
            <div class="mt-3 d-flex justify-content-end vertical-center" v-else-if="item.userType !== -1">
              <v-btn class="ml-5 button-normal" small @click="blockUserTask(item.userId, true)">
                <span>{{ $t('block') }}</span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="py-40 center" v-else>
        <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>

    <!-- Service Fee Modal -->
    <v-dialog v-model="serviceFeeModal" persistent max-width="400">
      <v-card>
        <v-card-title>{{ $t('change_service_fee') }}</v-card-title>
        <v-card-text>
          <div class="mt-4">
            <v-text-field
              v-model="modalServiceFee"
              :label="`${$t('service_fee')} (€)`"
              type="number"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="modalServiceTax"
              :label="`${$t('service_fee_percent')} (%)`"
              type="number"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="serviceFeeModal = false">{{ $t('cancel') }}</v-btn>
          <v-btn class="button-normal" text @click="setServiceFeeTask">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { getDecimalFormat, getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';

const defaultServiceTax = 6.5;
const defaultServiceFee = 1.2;

export default {
  name: 'UserList',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    colSmSize() {
      return this.$store.state.colSmSize;
    },
    statsMap() {
      return this.$store.state.statsMap;
    },
    userType() {
      return parseInt(this.$route.params.type);
    },
    userList() {
      return this.$store.state.userList;
    }
  },
  watch: {
    userType() {
      if (this.keyword) {
        this.keyword = '';
      } else {
        this.refreshData();
      }
    },
    userList() {
      this.refreshData();
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile
      },
      items: [],
      keyword: '',
      serviceFeeModal: false,
      modalServiceFee: 0,
      modalServiceTax: 0,
      selectedUser: null
    }
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    getDecimalFormat,
    getDateStringFromTimestamp,
    openServiceFeeModal(item) {
      this.selectedUser = item;
      // Set default values (replace with actual values if available)
      this.modalServiceFee = item.serviceFee ?  item.serviceFee / 100 : defaultServiceFee; // Because it will be stored as integer in cents
      this.modalServiceTax = item.serviceTax || defaultServiceTax;
      this.serviceFeeModal = true;
    },
    refreshData() {
      if (this.userList) {
        const keyword = this.keyword.toLowerCase();
        const items = this.userList.filter(element => element.userType === this.userType && element.userName.toLowerCase().includes(keyword));
        items.sort((a, b) => (a.createdAt.seconds < b.createdAt.seconds) ? 1 : -1);
        this.items = items;
      }
    },
    setUserTypeTask(userId, userType) {
      if (!confirm(this.$t(`${userType === 1 ? 'confirm_approve_organizer' : 'confirm_approve_single_user'}`))) {
        return;
      }
      const params = {
        functionName: 'setUserType',
        userId: userId,
        userType: userType
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    blockUserTask(userId, isBlock) {
      if (!confirm(this.$t(`${isBlock ? 'confirm_block_user' : 'confirm_unblock_user'}`))) {
        return;
      }
      const params = {
        functionName: isBlock ? 'blockUser' : 'unblockUser',
        userId: userId
      };
      if (isBlock) {
        const reason = prompt(this.$t('reason'));
        if (reason) {
          params['reason'] = reason;
        } else {
          return;
        }
      }
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    setServiceFeeTask() {
      // Implement the logic to set service fee and tax for the selected user
      // Example: console.log('Setting service fee for', this.selectedUser.userId, this.modalServiceFee, this.modalServiceTax);
      if (!this.selectedUser) {
        this.$toast.error(this.$t('no_user_selected'));
        return;
      }
      if (this.modalServiceFee <= 0) {
        this.$toast.error(this.$t('invalid_service_fee'));
        return;
      }
      if (this.modalServiceTax <= 0 || this.modalServiceTax > 100) {
        this.$toast.error(this.$t('invalid_service_tax'));
        return;
      }
      const params = {
        functionName: 'setServiceFee',
        userId: this.selectedUser.userId,
        serviceFee: Math.round(this.modalServiceFee * 100), // Store as integer in cents
        serviceTax: Number(this.modalServiceTax) // convert to number
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      }).finally(() => {
        this.serviceFeeModal = false;
      });
    }
  }
};
</script>

<style scoped>
::v-deep .v-text-field input {
  border: none !important;
}
</style>